// Salin teks ke papan klip. API Clipboard (butuh HTTPS & izin) lebih dulu; bila tidak tersedia/ditolak, cadangan lama
// lewat textarea tersembunyi + document.execCommand("copy"). Hasil: true bila berhasil, false bila keduanya gagal (UI lalu
// meminta salin manual -- tautan tetap tampil sbg teks yg bisa dipilih).
export async function salinTeks(teks) {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(teks);
            return true;
        }
    } catch {
        // jatuh ke cara lama di bawah
    }
    let area;
    try {
        area = document.createElement("textarea");
        area.value = teks;
        area.setAttribute("readonly", "");
        area.style.position = "fixed";
        area.style.opacity = "0";
        document.body.appendChild(area);
        area.select();
        return document.execCommand("copy") === true;
    } catch {
        return false;
    } finally {
        area?.remove();
    }
}
